import React from 'react'
import { useTranslation } from 'react-i18next'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useCopyToClipboard } from '~/hooks/useCopyToClipboard'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { type StrategyMemo } from '../hooks/useStrategyMemosInfiniteQuery'

export type ShareButtonProps = {
  strategyMemo: StrategyMemo
}

export const ShareButton = ({ strategyMemo }: ShareButtonProps) => {
  const { t } = useTranslation()
  const brandAccountId = useBrandAccountId()
  const copyToClipboard = useCopyToClipboard()
  const logEvent = useLogEvent()
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    const url = `${window.location.origin}${compile('strategyMemoEdit', {
      brandAccountId,
      strategyMemoId: strategyMemo.id,
    })}`
    copyToClipboard(url, {
      notificationText: t('strategymemo_title_url_copied_to_clipboard_1', {
        title: strategyMemo.title,
      }),
    })
    logEvent('Share customer strategy')
  }, [
    brandAccountId,
    copyToClipboard,
    strategyMemo.id,
    strategyMemo.title,
    logEvent,
    t,
  ])

  return (
    <StyledButton fillMode="outline" icon="share" onClick={handleClick}>
      {t('share_1')}
    </StyledButton>
  )
}
